import React, { useState } from "react";

import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";

import TextFieldCustom from "../../components/basic/TextFieldCustom";
import Btn from "../../components/buttons/Btn";
import { notify } from "../../utils/notify";
import { postPortalVideoCustomer } from "../../repositories/v1/portalVideoCustomer";
import MaskService from "../../utils/mask/maskService";

function VideoAccountantEdit({
  cnpj,
  reason,
  videoUrl,
  handleClose,
  handleAddUrl,
}) {
  const [url, setUrl] = useState(videoUrl || "");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      if (!url) return setErrors({ url: "Campo obrigatório" });

      setLoading(true);

      const resp = await postPortalVideoCustomer({
        cnpj,
        body: { VideoUrl: url },
      });

      if (!resp?.data?.success) {
        return notify("Não foi possível salvar os dados.");
      }

      notify("Vídeo vinculado com sucesso.", true, "info");
      handleAddUrl({ CNPJ: cnpj, VideoUrl: url, updatedAt: new Date() });
      handleClose();
    } catch (error) {
      console.error(error);
      notify("Não foi possível salvar os dados.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={!!cnpj}
      onClose={handleClose}
      aria-labelledby="dialog-video"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="dialog-video">Cadastro de Vídeo</DialogTitle>
      <DialogContent>
        <Grid
          container
          alignItems="center"
          justify="center"
          className="fadeInDown"
          spacing={2}
        >
          <Grid item sm={10} xs={12}>
            <TextFieldCustom
              disabled
              label="CNPJ/CPF"
              type="text"
              value={MaskService.toMask(
                (cnpj || "").length > 11 ? "cnpj" : "cpf",
                cnpj || ""
              )}
            />
          </Grid>

          <Grid item sm={10} xs={12}>
            <TextFieldCustom
              disabled
              label="Razão"
              type="text"
              value={reason || ""}
            />
          </Grid>

          <Grid item sm={10} xs={12}>
            <TextFieldCustom
              maxLength={255}
              label="Vídeo URL*"
              type="text"
              value={url}
              setValue={setUrl}
              error={errors.url}
              helperText={errors.url}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {!loading && (
          <Btn
            onClick={handleClose}
            label="Cancelar"
            bg-color="subGray"
            textcolor="gray"
          />
        )}

        <Btn
          onClick={handleSave}
          label={
            loading ? (
              <CircularProgress
                style={{ width: 22, height: 22, color: "white" }}
              />
            ) : (
              "Salvar"
            )
          }
        />
      </DialogActions>
    </Dialog>
  );
}

export { VideoAccountantEdit };
